var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocalizacaoButton({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_362)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0879 5.50502C12.8082 5.50502 12.5879 5.32475 12.5879 5.09595V1.80947C12.5879 1.58066 12.8082 1.40039 13.0879 1.40039C13.3676 1.40039 13.5879 1.58066 13.5879 1.80947V5.09595C13.5879 5.32475 13.3676 5.50502 13.0879 5.50502Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.591 12.9941H20.3114C20.0826 12.9941 19.9023 12.7738 19.9023 12.4941C19.9023 12.2145 20.0826 11.9941 20.3114 11.9941H23.591C23.8198 11.9941 24 12.2145 24 12.4941C24 12.7738 23.8198 12.9941 23.591 12.9941Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0879 23.4004C12.8082 23.4004 12.5879 23.2202 12.5879 22.9914V19.7118C12.5879 19.483 12.8082 19.3027 13.0879 19.3027C13.3676 19.3027 13.5879 19.483 13.5879 19.7118V22.9914C13.5879 23.2202 13.3676 23.4004 13.0879 23.4004Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.69556 12.9941H2.40908C2.18027 12.9941 2 12.7738 2 12.4941C2 12.2145 2.18027 11.9941 2.40908 11.9941H5.69556C5.92436 11.9941 6.10463 12.2145 6.10463 12.4941C6.10463 12.7738 5.92436 12.9941 5.69556 12.9941Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9971 14.6222C14.2263 14.6222 15.2228 13.6257 15.2228 12.3966C15.2228 11.1674 14.2263 10.1709 12.9971 10.1709C11.7679 10.1709 10.7715 11.1674 10.7715 12.3966C10.7715 13.6257 11.7679 14.6222 12.9971 14.6222Z",
    fill: "#848484"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 19.4004C16.866 19.4004 20 16.2664 20 12.4004C20 8.5344 16.866 5.40039 13 5.40039C9.134 5.40039 6 8.5344 6 12.4004C6 16.2664 9.134 19.4004 13 19.4004Z",
    stroke: "#848484",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_362"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(2 1.40039)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalizacaoButton);
export default __webpack_public_path__ + "static/media/localizacao-button.d4ccdc95218bf040866a895ae937e149.svg";
export { ForwardRef as ReactComponent };